import { AppVersion } from './app.type'

export enum Role {
  PowerUser = 'power_user',
  Admin = 'admin',
  User = 'user',
  Unknown = 'unknown',
  Anonymous = 'anonymous',
}

export enum PermissionResolver {
  FI = 'FI',
}

export interface RolePayloadForFI {
  test: string
  production: string
}

export interface FirebaseTokenCustomClaims {
  app: AppVersion
  email: string
  role: Role
  roles: string[]
}
